interface IEmptyResult {
  text: string;
}
function EmptyResult({ text }: IEmptyResult) {
  return <span className="text-slate-500 italic text-sm">{text}</span>;
}

export default EmptyResult;
